<template>
  <div class="rechargeHistoryWrap">
    <div class="formWrap">
      <el-form :inline="true">
        <el-form-item label="交易时间：">
          <el-date-picker
            v-model="time"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
            popper-class="recharge-picker"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="raidoTime" @change="radioChange">
            <el-radio-button :label="1">今天</el-radio-button>
            <el-radio-button :label="2">本周</el-radio-button>
            <el-radio-button :label="3">本月</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="goSearch()" type="primary">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableWrap">
      <el-table style="width: 100%" v-loading="tableLoading" :data="rechargeRecordsList" stripe>
        <el-table-column label="交易时间" width="170px" prop="createTime">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime && getfotmatMoment(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="资金流水ID" width="180px" prop="id">
        </el-table-column>
        <el-table-column label="企业订单号" width="180px" prop="tradeId">
        </el-table-column>
        <el-table-column label="交易类型" width="120px" prop="tradeType">
          <template slot-scope="scope">
            <span v-if="scope.row.tradeType == 'recharge'">第三方充值</span>
            <span v-if="scope.row.tradeType == 'Offline_in'">线下认款转入</span>
          </template>
        </el-table-column>
        <el-table-column label="操作金额（元）" width="160px" props="amount">
          <template slot-scope="scope">
            <span>{{scope.row.amount/100}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易备注" prop="remark">
        </el-table-column>
      </el-table>

    </div>
    <div class="paginationWrap" v-if="rechargeRecordsList.length > 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :total="RecordsTotal" :page-sizes="[5, 10, 20]" :page-size="pageSize"
        layout="total, prev, pager, next,sizes" background>
      </el-pagination>
    </div>
    <div class="noRecordsWrap" v-if="rechargeRecordsList.length == 0 && tableLoading == false">
      <p>暂无充值记录</p>
    </div>
  </div>
</template>
<script>
// import { mapState } from 'vuex'
import { Message } from 'element-ui'
import moment from 'moment'
export default {
  data () {
    return {
      time: '',
      status: '',
      pageNum: 1,
      pageSize: 10,
      tableLoading: false,
      rechargeRecordsList: [],
      RecordsTotal: 0,
      raidoTime: ''
    }
  },
  mounted: function () {
    let startTime = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
    let endtTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    this.time = [startTime, endtTime]
    if (this.$store.state.header.selfGroup && Object.keys(this.$store.state.header.selfGroup).length > 0) {
      this.getRecords()
    }
  },
  watch: {
    '$store.state.recharge.rechargeRecords': {
      handler: function (newVal) {
        this.tableLoading = false
        if (newVal) {
          this.RecordsTotal = newVal.total || 0
          this.rechargeRecordsList = newVal.dataList || []
        }
      }
    }
  },
  methods: {
    getRecords: function () {
      console.log('this.time', this.time)
      let startTime = this.time ? moment(this.time[0]).unix() : ''
      let endTime = this.time ? moment(this.time[1]).unix() : ''
      this.tableLoading = true
      if (!startTime || !endTime) {
        return Message.error('请选择时间范围')
      } else {
        this.$store.dispatch('recharge/getRechargeRecords', {
          groupId: this.$store.state.header.selfGroup.groupId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          startTime,
          endTime
        })
      }
    },
    getfotmatMoment (timeStr) {
      return moment(timeStr * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    radioChange (e) {
      let startTime = ''
      let endTime = ''
      if (e === 1) {
        startTime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        endTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      if (e === 2) {
        startTime = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
        endTime = moment().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      }
      if (e === 3) {
        startTime = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
        endTime = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      }
      this.time = [startTime, endTime]
    },
    handleSizeChange: function (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getRecords()
    },
    handleCurrentChange: function (val) {
      this.pageNum = val
      this.getRecords()
    },
    goSearch: function () {
      this.pageNum = 1
      this.getRecords()
    }
  }
}
</script>

<style lang="stylus">
.rechargeHistoryWrap
  padding 20px
  .formWrap
      padding-left 20px
      .el-input__inner
          border-radius 0
          border 1px solid #ccc
      .el-radio-button__inner
        border 1px solid #DCDFE6
        border-radius 4px
        -webkit-box-shadow none!important
        margin-right 10px
        box-shadow none!important
      .el-radio-button__orig-radio:checked+.el-radio-button__inner
        background #3468FF
  .paginationWrap
      text-align right
      padding-top 20px
      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
          border-radius 0
      .el-pagination.is-background .el-pager li:not(.disabled).active
          background #3468FF
      .el-pagination .el-select .el-input .el-input__inner
          height 28px
          line-height 28px
          border-radius 0
.noRecordsWrap
  width 560px
  margin 100px auto 0
  text-align center
  p
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    text-align center
    margin 0 0 20px 0
    background-image url('../../images/billnodata.png')
    background-position top center
    background-size 120px
    padding-top 150px
    background-repeat no-repeat
.el-table__empty-block
  display none
.recharge-picker
  .el-button--text
    display none
</style>
